import styled from "@emotion/styled"
import { ShadowContainer } from "../../../../styled/layout.styled"

export const IdeaCreateMeetingDateContainer = styled(ShadowContainer)({
  padding: "10px",
})
